module.exports = __webpack_public_path__ + "img/privacy_guaranteed.f606cf71.png";